// URL.parse() polyfill for Safari < 18
// pdfjs-dist@5.x uses URL.parse() which is not supported in older browsers
if (typeof URL.parse !== 'function') {
    URL.parse = function (url: string, base?: string | URL): URL | null {
        try {
            return new URL(url, base);
        } catch {
            return null;
        }
    };
}

// Promise.withResolvers() polyfill for Chrome < 119 / older browsers
// pdfjs-dist uses Promise.withResolvers() which is ES2024 and not available
// in older browser versions. Cast to `any` to avoid TS lib target errors.
if (typeof (Promise as any).withResolvers !== 'function') {
    (Promise as any).withResolvers = function <T>() {
        let resolve!: (value: T | PromiseLike<T>) => void;
        let reject!: (reason?: unknown) => void;
        const promise = new Promise<T>((res, rej) => {
            resolve = res;
            reject = rej;
        });
        return { promise, resolve, reject };
    };
}
